import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.25" cy="8" r="7.5" fill="#fff"/><path d="M4.352 7.982l2.35 2.182 4.95-4.5" stroke="#000"/></svg>`;

export { symbol as default };
